import { faChevronLeft } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Box, Button, CircularProgress, FormControl, FormControlLabel, Radio, RadioGroup, Typography, useMediaQuery } from "@mui/material";
import { useEffect, useState } from "react";
import { TipoOrientacaoTriagem } from "../../../interfaces/entities/TipoOrientacaoTriagem";
import { getTipoOrientacaoTriagem } from "../../../services/SaudeOnlineService";
import { sxButton, sxCircularLoadingProgress } from "./sxProps";
import { useAccessibility } from "../../../Store/contexts/AccessibilityContext";

const StepSintoma = (props: { backStep: () => void, nextStep: (sintoma: TipoOrientacaoTriagem) => void }) => {

  const [tipoOrientacaoTriagemList, setTipoOrientacaoTriagemList] = useState<TipoOrientacaoTriagem[]>([]);
  const [selectedOption, setSelectedOption] = useState<TipoOrientacaoTriagem | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const { backStep, nextStep } = { ...props };
  const mobileScreen = useMediaQuery('(max-width: 768px)');

  const accessibility = useAccessibility();


  useEffect(() => {
    fetchTipoOrientacaoTriagem();
  }, []);

  const handleOptionChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    let selectedValue = event.target.value;
    let selectedSymptom = tipoOrientacaoTriagemList.find(
      (item) => item.codTipoTeleOrientacao === selectedValue
    );
    if (selectedSymptom) {
      setSelectedOption(selectedSymptom);
    }
  };

  const fetchTipoOrientacaoTriagem = async () => {
    setLoading(true);
    const result = await getTipoOrientacaoTriagem();
    if (result?.status === 200) {
      let resultTeleorientacao: TipoOrientacaoTriagem[] = result.data;
      setTipoOrientacaoTriagemList(resultTeleorientacao);
    } else {
      console.error('Falha ao buscar tipos de orientação TRIAGEM.');
    }
    setLoading(false);
  };

  const handleProceed = () => {
    nextStep(selectedOption!);
  }

  return (
    <>
      {loading ? <Box children={<CircularProgress />} sx={sxCircularLoadingProgress} /> :
        <Box display={'flex'} flexDirection={'column'} alignItems={'flex-start'} gap={'25px'}>
          <Typography fontFamily={'Unimed-Sans'} component="h2" color={'#383838'} style={accessibility.textStyleAccessibility}>
            <b>Selecione o sintoma apresentado</b> <i>(apenas uma opção):</i>
          </Typography>

          <FormControl component="fieldset">
            <RadioGroup
              aria-label="selecione o sintoma apresentado (apenas uma opção)"
              name="tiposOrientacaoTriagem"
              value={selectedOption?.codTipoTeleOrientacao}
              onChange={handleOptionChange}
            >
              {tipoOrientacaoTriagemList.map((item) => (
                <FormControlLabel
                  key={item.codTipoTeleOrientacao}
                  value={item.codTipoTeleOrientacao}
                  control={<Radio style={accessibility.textStyleAccessibility} />}
                  label={
                    <span style={accessibility.textStyleAccessibility} className='pa-virtual-option'>
                        {item.descr}
                    </span>
                  }
                />
              ))}
            </RadioGroup>
          </FormControl>
          <Button
            variant="contained"
            size="large"
            onClick={handleProceed}
            style={accessibility.buttonStyleAccessibility}
            sx={sxButton}
            disabled={!selectedOption}
            fullWidth={mobileScreen}>
              <span style={accessibility.buttonTextStyleAccessibility}>
              PROSSEGUIR
              </span>
          </Button>
          <button className="back-button" onClick={backStep} style={accessibility.textStyleAccessibility} aria-label="Voltar para regras de atendimento">
            <FontAwesomeIcon style={accessibility.textStyleAccessibility} icon={faChevronLeft} />&nbsp;&nbsp;<u>Voltar</u>
          </button>
        </Box>
      }
    </>
  )
}

export default StepSintoma;